import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/readAxios';
const MyVehicleType = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        // $("#searchType .dropdown").removeClass("dropdown")
        setloading(true)
        ReadAxios({ masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/vehicleTypeMaster`, method: "post" })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = index + 1
            temp.text = object.vehicleType
            temp.value = object.vehicleTypeId
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        content.filter((item) => {
            if (data.value === item.vehicleTypeId) {
                props.getVehicleType(item)
            }
        })
    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: "100%", fontWeight: "normal" }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            error={props.error}
            noResultsMessage="Search for Result"
            {...props}
        />
    )
}
export default MyVehicleType